// extracted by mini-css-extract-plugin
export default {"employee-header":"Header_employee-header__Ebg7C","employee-header-item":"Header_employee-header-item__cGmm1"};